export enum IdPResponseError {
  InvalidGrant = 'invalid_grant',
  InvalidManagementGroup = 'invalid_management_group',
}
